module.exports = __webpack_public_path__ + "fonts/font.ac24fcd.woff2";